import React, { useState } from "react";

const ModalEditTrip = ({
                         onCancel,
                         onSubmit
                       }) => {
  const [minutes, setMinutes] = useState(0);

  return (
    <div>
      <div className="form-group">
        <label>Minutes</label>
        <input
          className="form-control"
          type="number"
          min={0}
          placeholder="Number greater then 0"
          onChange={ev => setMinutes(Number(ev.target.value))}
          value={minutes}
        />
      </div>

      <div className="text-right">
        <button
          className="btn btn-danger mr-2"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          className="btn btn-success"
          onClick={() => onSubmit(minutes)}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default ModalEditTrip;



// WEBPACK FOOTER //
// ./src/views/pages/users/modal-edit-trip.js